"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _pick = _interopRequireDefault(require("lodash/pick"));
var _get = _interopRequireDefault(require("lodash/get"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Li = require("@nerdwallet/currency/components/Li");
var _Link = require("@nerdwallet/currency/components/Link");
var _List = require("@nerdwallet/currency/components/List");
var _Title = require("@nerdwallet/currency/components/Title");
var _Type = require("@nerdwallet/currency/components/Type");
var _reactImage = _interopRequireDefault(require("@nerdwallet/react-image"));
var _htmlToNdsModule = _interopRequireDefault(require("../html-to-nds.module.css"));
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

var safeUrl = function safeUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var onSafe = arguments.length > 1 ? arguments[1] : undefined;
  var onUnsafe = arguments.length > 2 ? arguments[2] : undefined;
  return String(url).indexOf('https://') === 0 ? onSafe() : onUnsafe();
};
var NDSLib = {
  ol: function ol(node, children) {
    return /*#__PURE__*/_react.default.createElement(_List.List, {
      ordered: true
    }, children);
  },
  ul: function ul(node, children) {
    return /*#__PURE__*/_react.default.createElement(_List.List, null, children);
  },
  li: function li(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Li.Li, null, children);
  },
  h1: function h1(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Title.Title, {
      component: "h1"
    }, children);
  },
  h2: function h2(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Title.Title, {
      component: "h2"
    }, children);
  },
  h3: function h3(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Title.Title, {
      component: "h3"
    }, children);
  },
  h4: function h4(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Title.Title, {
      component: "h4"
    }, children);
  },
  h5: function h5(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Title.Title, {
      component: "h5"
    }, children);
  },
  h6: function h6(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Type.Type, {
      component: "h6",
      size: "2",
      bold: true
    }, children);
  },
  p: function p(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Type.Type, null, children);
  },
  a: function a(node, children) {
    return safeUrl(node.attribs.href, function () {
      return /*#__PURE__*/_react.default.createElement(_Link.Link, (0, _pick.default)(node.attribs, ['href', 'title', 'target']), children);
    }, function () {
      return /*#__PURE__*/_react.default.createElement(_Type.Type, {
        inline: true
      }, children);
    });
  },
  sup: function sup(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Type.Type, {
      inline: true,
      className: (0, _classnames.default)([_htmlToNdsModule.default['nds-sup']])
    }, children);
  },
  '&reg;': function reg() {
    return '®';
  },
  '&copy;': function copy() {
    return '©';
  },
  '&#8480;': function _() {
    return '℠';
  },
  '&#x2120;': function x2120() {
    return '℠';
  },
  img: function img(node) {
    return safeUrl(node.attribs.src, function () {
      return /*#__PURE__*/_react.default.createElement(_reactImage.default, (0, _extends2.default)({}, (0, _pick.default)(node.attribs, ['title', 'width', 'height']), {
        src: node.attribs.src,
        alt: node.attribs.alt
      }));
    }, function () {
      return (0, _get.default)(node.attribs, 'alt', '') ? /*#__PURE__*/_react.default.createElement(_Type.Type, {
        inline: true
      }, node.attribs.alt) : null;
    });
  },
  generic: function generic(node, children) {
    return /*#__PURE__*/_react.default.createElement(_Type.Type, {
      inline: true,
      bold: node.name === 'strong' || node.name === 'b',
      italic: node.name === 'em' || node.name === 'i'
    }, children);
  }
};
var _default = NDSLib;
exports.default = _default;